import { IQuota, IQuotaCompletes } from "./IQuota";
import { IQuotaTable } from "./IQuotaTable";
import { ITarget } from "./ITarget";
import { IQuestion } from "./IQuestion";
import { IResearchCategory, ResearchCategory } from './IResearchCategory'
import { ICost, Cost, ICostByFieldDuration } from './ICost';
import { ITemplateFieldDuration } from './ITemplateFieldDuration';
import { QuotaAllocationMode, QuotaAllocationModeById, QuotaAllocationModeByName } from '../enums/quota-allocation-mode.enum';
import { FeasibilityCheckSupplierModeList, FeasibilityCheckSupplierModeById, FeasibilityCheckSupplierMode } from "../enums/feasibility-check-supplier-mode.enum";

export interface ISample {
  id: number;
  feasibilityId: string;
  countryCode: string;
  countryCultures: Array<string>;
  _daysInField: number;
  _hoursInField: number;
  hoursInField: number;
  flexibleFieldDuration: boolean;
  fieldDurationTemplate: ITemplateFieldDuration;
  fieldStartDate: Date;
  lengthOfInterview: number;
  sampleCategory: string;
  sampleCategoryId: number;
  sampleSubCategory: string;
  sampleSubCategoryId: number;
  researchType: string;
  researchCategories: Array<IResearchCategory>;
  allowMobile: boolean;
  allowTablet: boolean;
  allowDesktop: boolean;
  collectPII: boolean;
  facialCoding: boolean;
  quotaTables: Array<IQuotaTable>;
  abandonRatePercent: number;
  incidenceRatePercent: number;
  sniffoutRatePercent: number;
  technologyCoefficient: number;
  supplierTrustCoefficient: number;
  supplierTotalCompletes: IQuotaCompletes;
  sourceSupplierFeasibilityResponseIds: IQuotaCompletes;//fd->sourceId
  numberOfCompletes: string;
  supplier: string;
  supplierId: number;
  internalSupplier: boolean;
  virtualPanel: boolean;
  testingPhase: boolean;
  quotaAllocationMode: string;//only in response
  //cost: ICost;
  costs: ICostByFieldDuration;
  target: ITarget[];
  dateCreated: Date;
  dateUpdated: Date;
  sampleName: string;
  targetType: string;
  targetTypeId: number;
  sampleType: string;
  sampleTypeId: number;
  cellType: string;
  cellTypeId: number;
  templateAudienceDesignerId: number;
  sampleMethodology: string;
  sampleMethodologyId: number;
  completesStructure: string;
  quotasDistribution: string;
  cells: number;
  eliminationMonths: number;
  feasibilityCheckEnabled: boolean;
  additionalCustomVariables: string;
  numberOfAdditionalCustomVariables: number;
  feasibilityCheckSupplierMode: string;
  overlapFeasibilities: ISample[];
  responseCode: string;
  calculateMaxBlend: boolean;
  duration: string;
  endpoint: string;
  supplierFeasibilityResponseId: number;
  genPopIncidenceRatePercent: number;
  interlocked: boolean;
  totalTrackerNumberOfCompletes: number;
  waveNumberOfCompletes: number;
  sampleOneApiCompatible: boolean;
  subSampleId: number;
}

export class Sample implements ISample {
  id: number;
  feasibilityId: string;
  countryCode: string;
  countryCultures: Array<string>;
  _daysInField: number;
  _hoursInField: number;
  hoursInField: number;
  flexibleFieldDuration: boolean;
  fieldStartDate: Date;
  lengthOfInterview: number;
  sampleCategoryId: number;
  sampleSubCategoryId: number;
  sampleCategory: string;
  sampleSubCategory: string;
  researchType: string;
  collectPII: boolean;
  facialCoding: boolean;
  researchCategories: Array<IResearchCategory>;
  allowMobile: boolean;
  allowTablet: boolean;
  allowDesktop: boolean;
  quotaTables: Array<IQuotaTable>;
  abandonRatePercent: number;
  incidenceRatePercent: number;
  sniffoutRatePercent: number;
  technologyCoefficient: number;
  supplierTrustCoefficient: number;
  supplierTotalCompletes: IQuotaCompletes;
  sourceSupplierFeasibilityResponseIds: IQuotaCompletes;//fd->sourceId
  recommendedFieldDurations: Array<string>;
  numberOfCompletes: string;
  supplier: string;
  supplierId: number;
  internalSupplier: boolean;
  virtualPanel: boolean;
  testingPhase:boolean;
  quotaAllocationMode: string;
  costs: ICostByFieldDuration;
  target: ITarget[];
  sampleName: string;
  dateCreated: Date;
  dateUpdated: Date;
  targetType: string;
  targetTypeId: number;
  sampleType: string;
  sampleTypeId: number;
  cellType: string;
  cellTypeId: number;
  templateAudienceDesignerId: number;
  sampleMethodology: string;
  sampleMethodologyId: number;
  completesStructure: string;
  quotasDistribution: string;
  cells: number;
  eliminationMonths: number;
  feasibilityCheckEnabled: boolean;
  additionalCustomVariables: string;
  numberOfAdditionalCustomVariables: number;
  feasibilityCheckSupplierMode: string;
  overlapFeasibilities: ISample[];
  responseCode: string;
  calculateMaxBlend: boolean;
  duration: string;
  endpoint: string;
  supplierFeasibilityResponseId: number;
  genPopIncidenceRatePercent: number;
  fieldDurationTemplate: ITemplateFieldDuration;
  interlocked: boolean;
  totalTrackerNumberOfCompletes: number;
  waveNumberOfCompletes : number;
  sampleOneApiCompatible: boolean;
  subSampleId: number;

    constructor(id: number = 0) {
        this.id = id;
        this.countryCode = null;
        this.allowDesktop = true;
        this.allowTablet = true;
        this.allowMobile = true;
        this.collectPII = false;
        this.facialCoding = false;
        this.researchCategories = [new ResearchCategory()];
        this.quotaTables = [];
        this.countryCultures = [];
        this.flexibleFieldDuration = false;
        this.abandonRatePercent = 0;
        this.sniffoutRatePercent = 0;
        this.supplierTotalCompletes = null;
        this.recommendedFieldDurations = null;
        this.numberOfCompletes = "0";
        this._daysInField = 0;
        this._hoursInField = 0;
        this.hoursInField = 0;
        //this.cost = new Cost();
        this.target = [];
        this.quotaAllocationMode = QuotaAllocationModeById(QuotaAllocationMode.MaxNonBalanced).name;
        this.feasibilityCheckEnabled = true;
        this.feasibilityCheckSupplierMode = FeasibilityCheckSupplierModeById(FeasibilityCheckSupplierMode.AllSuppliers).name;
        this.responseCode = null;
        this.calculateMaxBlend = false;
        this.duration = "";
        this.endpoint = "";
        this.interlocked = false;
        this.sampleOneApiCompatible = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/ISample.ts